import { useEffect, useState } from 'react';

import { useTrackGrow465Experiment } from './use-track-grow-465-experiment';
import { useTrackGrow466Experiment } from './use-track-grow-466-experiment';
import { useTrackGrow518Experiment } from './use-track-grow-518-experiment';
import { useTrackGrow524Experiment } from './use-track-grow-524-experiment';
import { useTrackGrow709Experiment } from './use-track-grow-709-experiment';
import { useTrackGrow731Experiment } from './use-track-grow-731-experiment';
import { useTrackGrow741Experiment } from './use-track-grow-741-experiment';
import { useTrackGrow742Experiment } from './use-track-grow-742-experiment';
import { useTrackSingleLabelSellerExperiment } from './use-track-single-label-seller-experiment';
import { useAreFeatureFlagsReady } from '../../feature-flags/hooks/use-are-feature-flags-ready';
import { useEnableGrow518Experiment } from '../../feature-flags/hooks/use-enable-grow-518-experiment';
import { useQuery } from '../../hooks/routing/use-query';
import { useSellerOnboardingVariant } from '../../hooks/use-seller-setting';

export const useTrackGrowExperiments = () => {
  const ready = useAreFeatureFlagsReady();
  const query = useQuery();
  const [isFirstLogin, setIsFirstLogin] = useState(query.get('firsttime') === 'true');
  const grow518Variant = useEnableGrow518Experiment();
  const progressiveDisclosureVariant = useSellerOnboardingVariant();
  const trackGrow465Experiment = useTrackGrow465Experiment();
  const trackGrow466Experiment = useTrackGrow466Experiment({
    variant: progressiveDisclosureVariant,
  });
  const trackGrow518Experiment = useTrackGrow518Experiment({
    variant: grow518Variant,
  });
  const trackGrow524Experiment = useTrackGrow524Experiment();

  const trackByoSpeedbumpRemovalExperiment = useTrackGrow731Experiment();
  const trackGrow709Experiment = useTrackGrow709Experiment();
  const trackGrow741Experiment = useTrackGrow741Experiment();

  // First Time User experiments
  useEffect(() => {
    if (!ready) {
      return;
    }
    if (isFirstLogin) {
      trackGrow518Experiment();
      trackGrow466Experiment();
      trackGrow465Experiment();
      trackGrow524Experiment();
      trackGrow709Experiment();
      trackGrow741Experiment();
      trackByoSpeedbumpRemovalExperiment();
      setIsFirstLogin(false);
    }
  }, [
    isFirstLogin,
    ready,
    trackGrow518Experiment,
    trackGrow466Experiment,
    trackGrow465Experiment,
    trackGrow524Experiment,
    trackGrow709Experiment,
    trackGrow741Experiment,
    trackByoSpeedbumpRemovalExperiment,
  ]);

  // non-First Time User experiments
  // All calling logic — including lifecyce/rerendering control —
  // should be contained in the experiment's hook
  useTrackGrow742Experiment(ready);
  useTrackSingleLabelSellerExperiment(ready);
};
